module.exports = __webpack_public_path__ + "img/icon_fgyl.f8dcc930.png";